module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "cpytxt2"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_vm._v("Copyright © 2012 by T.J. Murphy")])])]), _c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("CrossFit"), _c('sup', [_vm._v("®")]), _vm._v(" is a registered trademark of CrossFit, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_c('span', [_vm._v("All rights reserved. Published in the United States of America by VeloPress, a division of Competitor Group, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt3"
  }, [_c('span', [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/logo.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("3002 Sterling Circle, Suite 100")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("Boulder, Colorado 80301-2338 USA")])])]), _c('p', {
    staticClass: "cpytxt"
  }, [_c('a', {
    attrs: {
      "id": "page_iv"
    }
  }, [_c('span', [_vm._v("(303) 440-0601 · Fax (303) 444-6788 · E-mail ")])]), _c('a', {
    attrs: {
      "href": "mailto:velopress@competitorgroup.com"
    }
  }, [_vm._v("velopress@competitorgroup.com")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt3"
  }, [_c('span', [_vm._v("Distributed in the United States and Canada by Ingram Publisher Services")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_c('span', [_vm._v("A Cataloging-in-Publication record for the printed edition is available from the Library of Congress.")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("ISBN 978-1-934030-90-5 (pbk.: alk. paper); ISBN 978-1-937716-21-9 (e-book)")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt1"
  }, [_c('span', [_vm._v("For information on purchasing VeloPress books, please call (800) 811-4210 ext. 2138 or visit "), _c('a', {
    attrs: {
      "href": "http://www.velopress.com",
      "target": "_blank"
    }
  }, [_vm._v("www.velopress.com")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt3"
  }, [_c('span', [_vm._v("Cover design by "), _c('i', [_vm._v("the")]), _vm._v("BookDesigners")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("Cover photograph by Nick Rudnicki")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("Interior design by Erin Johnson")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt"
  }, [_c('span', [_vm._v("Interior photographs by Robert Murphy, Scott Draper, and Caroline Treadway")])]), _vm._v(" "), _c('p', {
    staticClass: "cpytxt3"
  }, [_c('span', [_vm._v("V.3.0")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aefbb34e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 66
// module chunks = 0